export default __webpack_public_path__ + "static/media/placeholderImage.aadba29c.webp";